export default __webpack_public_path__ + "static/media/gefion2.1a25c479.jpeg";